
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.763 7.138l-8.562-2.941a.686.686 0 00-.403 0L1.236 7.138a.587.587 0 00-.403.564c0 .262.141.484.383.585l2.337.906v3.788a.6.6 0 00.342.523l4.735 2.438a3.116 3.116 0 002.74 0l4.734-2.438a.6.6 0 00.343-.523V9.193l1.309-.524v3.526c0 .342.262.604.604.604.323.02.585-.241.605-.564v-4.07a.656.656 0 00.201-.463.587.587 0 00-.403-.564zm-3.525 5.46l-4.412 2.256a1.834 1.834 0 01-1.652 0l-4.412-2.256V9.657L9.78 11.61c.14.06.302.06.443 0l5.016-1.954v2.94zM10 10.402l-6.81-2.64L10 5.427l6.809 2.337-6.81 2.639z","fill":"#9AA0B5"}})])
          )
        }
      }
    